export default __webpack_public_path__ + "static/media/solid_security_icon.02e171e9.svg";